import React, { useEffect } from "react";
import { Shield } from "lucide-react";
import RolesApi from "../../api/rolesApi";
import { useAuthUser } from "../../hooks/useAuthUser";
import { useBilingualMasterData } from "../../hooks/useBilingualMasterData";
import BilingualMasterPage from "../../components/masterData/BilingualMasterPage";

const rolesApi = new RolesApi();

const Roles = () => {
  const userData = useAuthUser();
  const {
    isError,
    validated,
    cp,
    icon_id,
    list: rolesDataList,
    show,
    LoadData,
    deleteAlert,
    matches,
    showConfirmationModal,
    setShowConfirmationModal,
    data,
    handleClose,
    handleCloseAlert,
    handleShow,
    handleChanges,
    handleSubmit,
    handleConfirmSubmit,
    CollectData,
    DeleteData,
    SearchData,
    fetchList,
    clearfield,
    searchKey,
  } = useBilingualMasterData({
    emptyData: { role: "", spanishRole: "" },
    englishField: "role",
    spanishField: "spanishRole",
    api: {
      add: (payload) => rolesApi.addRole(payload),
      update: (payload, id) => rolesApi.updateRole(payload, id),
      remove: (payload, id) => rolesApi.deleteRole(payload, id),
      list: () => rolesApi.getAllRoleList({} as any),
      search: (payload, key) => rolesApi.searchRole(payload, key),
    },
    sortList: null,
  });

  useEffect(() => {
    if (searchKey) {
      SearchData({ target: { value: searchKey } });
    } else {
      fetchList();
    }
  }, []);

  return (
    <BilingualMasterPage
      isAdmin={Boolean(userData && userData.userRole === "ADMIN")}
      formTitle="Add Service Role"
      listTitle="Service Roles"
      listSubtitle="Manage bilingual role names used on retreat rosters."
      formIcon={<Shield size={20} color="#285d8f" />}
      listIcon={<Shield size={20} color="#285d8f" />}
      englishLabel="Service Role"
      englishPlaceholder="Enter New Service Role"
      englishRequiredMessage="Service role is required!"
      englishField="role"
      spanishLabel="Spanish Service Role"
      spanishPlaceholder="Enter Spanish Service Role"
      spanishField="spanishRole"
      englishColumnName=" Service Role"
      spanishColumnName="Spanish Service Role"
      createdSortFormat="MM-DD-YYYY"
      dataKey="role"
      deleteTitle="Role Detail"
      deleteDetailLabel="Role"
      deleteAlertHeader="You are not able to delete this Role"
      deleteAlertMessage={
        <div>
          <h4>Retreat Roster(s) are added for this Role.</h4>{" "}
          <h5>
            If you want to delete this Role, first please change the Role for
            Retreat Rosters.
          </h5>
        </div>
      }
      isError={isError}
      validated={validated}
      cp={cp}
      icon_id={icon_id}
      list={rolesDataList}
      show={show}
      LoadData={LoadData}
      deleteAlert={deleteAlert}
      matches={matches}
      showConfirmationModal={showConfirmationModal}
      setShowConfirmationModal={setShowConfirmationModal}
      data={data}
      handleClose={handleClose}
      handleCloseAlert={handleCloseAlert}
      handleShow={handleShow}
      handleChanges={handleChanges}
      handleSubmit={handleSubmit}
      handleConfirmSubmit={handleConfirmSubmit}
      CollectData={CollectData}
      DeleteData={DeleteData}
      SearchData={SearchData}
      clearfield={clearfield}
      searchValue={searchKey}
    />
  );
};
export default Roles;
